import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 text-xl font-heading whitespace-nowrap cursor-pointer no-underline text-white mb-4">
              <i className="ri-play-circle-line text-2xl"></i>
              <span>芭乐视频</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              芭乐视频是您最值得信赖的免费水果视频平台，聚合蜜桃视频、西瓜视频、樱桃视频等热门平台资源，提供高清流畅的观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-white font-heading text-base mb-4">视频分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading text-base mb-4">快捷链接</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap"
                >
                  用户口碑
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading text-base mb-4">平台特色</h4>
            <ul className="space-y-2">
              <li className="text-sm text-foreground-400">高清画质 · 极速加载</li>
              <li className="text-sm text-foreground-400">完全免费 · 无需注册</li>
              <li className="text-sm text-foreground-400">每日更新 · 多端同步</li>
              <li className="text-sm text-foreground-400">安全可靠 · 资源丰富</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800/40 mt-10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 芭乐视频 - 水果视频平台。本站内容仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer no-underline whitespace-nowrap" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}